module.exports = __webpack_public_path__ + "static/clothing-sweatshirt-408ce53795b3262210c1e5d9a904b7ab.jpg";